import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { GameStatisticLabel, GameStatisticValue, GameStatisticWrapper } from './GameInfoStatistic.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface GameInfoStatisticPropsType {
    label: string;
    value: number | string;
}

export const GameInfoStatistic = observer(
    'GameInfoStatistic',
    ({ label, value }: GameInfoStatisticPropsType): JSX.Element => {
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;

        return (
            <GameStatisticWrapper variant={configState.componentVariants.casinoVariant}>
                <GameStatisticValue>{value}</GameStatisticValue>
                <GameStatisticLabel>{label}</GameStatisticLabel>
            </GameStatisticWrapper>
        );
    }
);
